import React from 'react';
import { Field, ErrorMessage } from 'formik';

const Fieldset = ({ name, label, ...rest }) => (
    <React.Fragment>
        <label htmlFor={name}>{label}</label>
        <Field id={name} name={name} {...rest} />
        <ErrorMessage name={name} />
    </React.Fragment>
);

export default Fieldset;
